import { Injectable } from '@angular/core'

import { Observable, map } from 'rxjs'

import { ActionDefinition } from '@flowx/designer/modules/core/dictionary/process.dictionary'
import {
  ApiHttpProxyService,
  ForwardProxyMicroservice,
} from '@flowx/designer/shared/api/api-http-proxy.service'
import {
  ApplicationResourceType,
  ProxyApiAction,
} from '@flowx/designer/shared/entities/application.entity'

@Injectable({
  providedIn: 'root',
})
export class ActionApi extends ApiHttpProxyService {
  updateAction(action: ActionDefinition): Observable<ActionDefinition> {
    return this.patch('api/actions', action, {
      microservice: ForwardProxyMicroservice.Admin,
      resourceType: ApplicationResourceType.Process,
      action: ProxyApiAction.UPDATE,
      resourceTypesToIncludeMappingFor: ['project-data-type'],
    }).pipe(map((response) => response.resourceContent))
  }

  deleteById(actionId: number): Observable<void> {
    return this.patch(`api/actions/${actionId}`, null, {
      microservice: ForwardProxyMicroservice.Admin,
      resourceType: ApplicationResourceType.Process,
      action: ProxyApiAction.DELETE,
    })
  }
}
